var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-item"},[(_vm.img)?_c('img',{attrs:{"src":require(`@/assets/icons/${_vm.img}.svg`),"alt":""}}):_vm._e(),_c('div',{staticClass:"notification-item__text"},[_vm._t("text")],2),_vm._t("button")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }